import clsx from 'clsx'
import Stepper from './Stepper'

const MAX_PER_TIER = 99

const PricingTable = ({
	name,
	price,
	note = 'inkl. moms',
	description,
	mostPopular = false,
	inputName,
	register,
	setValue,
	getValues,
	clearErrors,
	soldOut = false,
}) => {
	const quantity = getValues(inputName) || 0

	const step = (delta) => () => {
		const next = Math.min(MAX_PER_TIER, Math.max(0, (getValues(inputName) || 0) + delta))
		setValue(inputName, next, { shouldDirty: true })
		if (next > 0) clearErrors('tickets')
	}

	return (
		<li
			className={clsx(
				'hx-tier',
				mostPopular && !soldOut && 'hx-tier--popular',
				soldOut && 'hx-tier--soldout',
			)}
		>
			{mostPopular && !soldOut && (
				<span className='hx-tier__badge'>
					Rekommenderas
					<sup style={{ fontSize: '.8em', lineHeight: 0, marginLeft: 1 }}>*</sup>
				</span>
			)}

			<h3>{name}</h3>
			<div className='hx-tier__price'>{price} kr</div>
			<div className='hx-tier__note'>{note}</div>
			<div className='hx-tier__desc'>{description}</div>

			<div className='hx-tier__stepper'>
				<Stepper
					id={inputName}
					label={`biljett för ${name}`}
					disabled={soldOut}
					canDecrement={quantity > 0}
					canIncrement={quantity < MAX_PER_TIER}
					onDecrement={step(-1)}
					onIncrement={step(1)}
					inputProps={register(inputName, { min: 0, max: MAX_PER_TIER, valueAsNumber: true })}
					onInputChange={(event) => {
						const typed = parseInt(event.target.value, 10)
						if (Number.isNaN(typed) || typed < 0) setValue(inputName, 0)
						else if (typed > MAX_PER_TIER) setValue(inputName, MAX_PER_TIER)
						else if (typed > 0) clearErrors('tickets')
					}}
				/>
			</div>

			{soldOut && (
				<div className='hx-tier__soldout'>
					<span>SLUTSÅLT</span>
				</div>
			)}
		</li>
	)
}

export default PricingTable
